"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signal = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var Signal = function Signal(_a) {
  var __UIScope = _a.__UIScope,
      ariaLabel = _a["aria-label"],
      testID = _a["data-testid"],
      className = _a.className,
      _b = _a.colorPattern,
      colorPattern = _b === void 0 ? 'default' : _b,
      isHalo = _a.isHalo,
      isSonar = _a.isSonar,
      label = _a.label,
      _c = _a.size,
      size = _c === void 0 ? 'large' : _c;
  var rootClasses = ui_helper_deep_branding_1.useEscapeClasses({
    block: 'Signal',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    "aria-label": ariaLabel,
    colorPattern: colorPattern,
    size: size,
    isHalo: isHalo,
    isSonar: isSonar
  }), label && react_1.default.createElement(ui_text_1.Text, {
    scale: 3,
    ml: 0.75,
    font: "text",
    weight: "medium"
  }, label));
};

var SignalWithSpace = ui_helper_with_space_1.withSpace(Signal);
exports.Signal = SignalWithSpace;